import { useState } from "react";

import Modal from "../Util/Modal";

type ImportMinersModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (ip: string) => void;
};

export default function ImportMinersModal({
  isOpen,
  onClose,
  onSubmit,
}: ImportMinersModalProps) {

  interface IpRanges {
    ip1: String,
    ip2: String,
    ip3: String
  }

  const initIpRange = {
    ip1: '192',
    ip2: '168',
    ip3: ''
  };

  const [inputFields, setInputFields] = useState([initIpRange]);

  const addInputField = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setInputFields([...inputFields, initIpRange])
  }

  const removeInputFields = (index: number, event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    const rows = [...inputFields];
    rows.splice(index, 1);
    setInputFields(rows);
  }

  const handleChange = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const value = event.target.value;
    const list = [...inputFields];
    list[index][name as keyof IpRanges] = value;
    setInputFields(list);
  }

  const stringifyPayload = () => {
    const payload: any[] = [];
    inputFields.forEach((ip: IpRanges) => {
      payload.push(ip['ip1'] + "." + ip['ip2'] + "." + ip['ip3']);
    });
    return JSON.stringify(payload);
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`Import Miners`}>
      <>
        <button className="bg-white border-slate-200 px-2 py-6 font-medium text-xs text-blue-700" onClick={(event) => addInputField(event)}>Add New</button>
        <form className="flex flex-col">
          {
            inputFields.map((data, index) => {
              const { ip1, ip2, ip3 } = data;
              return (
                <div className="mb-4 pb-4 flex items-center border-gray-100 border-b" key={index}>
                  <div>
                    {(inputFields.length !== 1) ?
                      <button
                        className="form-input mr-8 rounded-sm border border-gray-200 text-xs text-pink-600"
                        onClick={(event) => removeInputFields(index, event)}
                      >
                        Remove
                      </button> : ''
                    }
                  </div>
                  <input
                    type="text"
                    onChange={(event) => handleChange(index, event)}
                    value={ip1}
                    name="ip1"
                    className="form-input w-16 mx-1 rounded-sm border border-gray-200 text-xs"
                    placeholder="192"
                  />
                  <span>.</span>
                  <input
                    type="text"
                    onChange={(event) => handleChange(index, event)}
                    value={ip2}
                    name="ip2"
                    className="form-input w-16 mx-1 rounded-sm border border-gray-200 text-xs"
                    placeholder="168"
                  />
                  <span>.</span>
                  <input
                    type="text"
                    onChange={(event) => handleChange(index, event)}
                    value={ip3}
                    name="ip3"
                    className="form-input w-16 mx-1 rounded-sm border border-gray-200 text-xs"
                    placeholder="???"
                  />
                  <div className="mx-1 text-xs">0 - 255</div>
                </div>
              )
            })
          }
        </form>
        <div className="mt-4 flex justify-end -m-6 px-6 bg-gray-50 py-5 border-t">
          <button
            type="button"
            className="form-input inline-flex items-center border border-transparent leading-4 font-medium shadow-sm text-white focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-sm px-4 text-sm py-2 bg-green-400 hover:bg-green-500 focus:ring-green-500"
            onClick={() => {
              onSubmit(stringifyPayload());
            }}
          >
            Scan
          </button>
          <button
            type="button"
            className="ml-3 inline-flex items-center border leading-4 font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 rounded-sm px-4 text-sm py-2 bg-white hover:bg-gray-50 text-current border-gray-200"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </>
    </Modal>
  );
}
